<template>
    <b-dropdown :variant="dropdownVariant" :size="size" :disabled="disabled" right>
        <template #button-content>
            <fa icon="globe" class="mr-2"></fa> {{selected_lang}}
        </template>
        <b-dropdown-item v-for="lang in langs"
            :key="lang.id"
            @click="updateLanguage(lang.value)"
            >
            {{ lang.text }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { localize } from 'vee-validate';

export default {
    name: 'dropdown-language',
    props: {
        lang: {
            type: String,
            required: false,
            default: null
        },
        dropdownVariant: {
            type: String,
            required: false,
            default: 'red-border'
        },
        size: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },

    },
    data () {
        return {
            langs: [
                { text: '한국어', value: 'ko' },
                { text: 'English', value: 'en' },
                { text: 'Chinese', value: 'ca' }
            ]
        };
    },
    computed: {
        selected_lang () {
            if (this.lang) {
                if (this.lang === 'ko') {
                    return 'KOR';
                } else if (this.lang === 'en') {
                    return 'ENG';
                } else {
                    return 'CHN';
                }
            } else {
                if (this.$i18n.locale === 'ko') {
                    return 'KOR';
                } else if (this.$i18n.locale === 'en') {
                    return 'ENG';
                } else {
                    return 'CHN';
                }
            }
        }
    },
    methods: {
        updateLanguage (_lang) {
            if (this.lang) {
                this.$emit('updateLang', _lang);
            } else {
                this.$i18n.locale = _lang;
                document.documentElement.lang = _lang;
                try {
                    localStorage.setItem('qesg_locale', _lang);
                } catch (e) { /* 저장소 접근 불가 — 이번 세션만 유지 */ }
            }
            localize(this.$i18n.locale);
        }
    }
};
</script>

<style>

</style>
